import React, { cloneElement, isValidElement } from 'react'
import PropTypes from 'prop-types'
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Grid,
  Typography
} from '@material-ui/core'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'

/**
 * Componente atômico para seções expansíveis com semântica de seção e WAI-ARIA completo.
 */
const SectionAccordion = ({
  id,
  title,
  expanded,
  onChange,
  children,
  classes = {},
  extraHeader = null,
  icon = null,
  TransitionProps = { unmountOnExit: true },
  ...rest
}) => {
  const isExpanded = expanded === id

  const handleAccordionChange = (event, newExpandedState) => {
    if (typeof onChange === 'function') {
      onChange(id)(event, newExpandedState)
    }
  }

  return (
    <Grid
      item
      xs={12}
      className={classes.boxGrid}
      component="section"
      aria-labelledby={`${id}-title`}
      {...rest}
    >
      <Accordion
        expanded={isExpanded}
        onChange={handleAccordionChange}
        elevation={0}
        className={classes.accordion}
        TransitionProps={TransitionProps}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon aria-hidden="true" />}
          id={`${id}-header`}
          aria-controls={`${id}-content`}
          aria-expanded={isExpanded}
        >
          <div className={classes.groupContent}>
            {isValidElement(icon) && (
              <div className={classes.groupIcon} aria-hidden="true">
                {cloneElement(icon, { size: 18, 'aria-hidden': true })}
              </div>
            )}

            <Typography
              component="h3"
              id={`${id}-title`}
              className={classes.groupTitle}
              variant="subtitle1"
            >
              {title}
            </Typography>

            {extraHeader && (
              <div
                className={classes.extraHeaderWrapper}
                onClick={e => e.stopPropagation()}
                onKeyDown={e => e.stopPropagation()}
              >
                {extraHeader}
              </div>
            )}
          </div>
        </AccordionSummary>

        <AccordionDetails
          className={classes.accordionDetailsHighlighted}
          id={`${id}-content`}
          role="region"
          aria-labelledby={`${id}-header`}
        >
          <div style={{ width: '100%', marginTop: '10px' }}>
            {children}
          </div>
        </AccordionDetails>
      </Accordion>
    </Grid>
  )
}

SectionAccordion.propTypes = {
  id: PropTypes.string.isRequired,
  title: PropTypes.node.isRequired,
  expanded: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]).isRequired,
  onChange: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
  classes: PropTypes.object,
  extraHeader: PropTypes.node,
  icon: PropTypes.element,
  TransitionProps: PropTypes.object
}

export default React.memo(SectionAccordion)